import React from 'react';
import { CardBody, Row } from 'reactstrap';
import ProfileBannerIntro from '../profile/ProfileBannerIntro';

const ProfileBannerBody = props => {
  return (
    <CardBody>
      <Row>
        <ProfileBannerIntro {...props} />
      </Row>
    </CardBody>
  );
};

export default ProfileBannerBody;
